module Bookhus.Widgets {
    interface IEmne {
        id: number;
        title: string;
    }

    class GuestbookTranslations {
        constructor() {

        }

        private translations: any = {
            writepost: {
                da: 'Skriv nyt indlæg',
                'en-GB': 'Write new post',
                sv: 'Skriva nytt inlägg',
                de: 'Neuen Beitrag schreiben',
                no: 'Skrive nytt innlegg'
            },
            name: {
                da: 'Navn',
                'en-GB': 'Name',
                sv: 'Namn',
                de: 'Name',
                no: 'Navn'
            },
            email: {
                da: 'E-mail',
                'en-GB': 'Email',
                sv: 'E-post',
                de: 'Email',
                no: 'E-post'
            },
            pickitem: {
                da: 'Vælg emne',
                'en-GB': 'Pick property',
                sv: 'Välj egendom',
                de: 'Immobilie auswählen',
                no: 'Velg eiendom'
            },
            message: {
                da: 'Din besked',
                'en-GB': 'Your messasge',
                sv: 'Ditt meddelande',
                de: 'Ihre Nachricht',
                no: 'Din beskjed'
            },
            attachfile: {
                da: 'Vedhæft evt. et billede',
                'en-GB': 'Attach an optional picture',
                sv: 'Bifoga en valfri bild',
                de: 'Hängen Sie ein optionales Bild an',
                no: 'Legg ved et valgfritt bilde'
            },
            pickfile: {
                da: 'Vælg en fil',
                'en-GB': 'Pick a file',
                sv: 'Välj en fil',
                de: 'Wählen Sie eine Datei aus',
                no: 'Velg en fil'
            },
            send: {
                da: 'Send',
                'en-GB': 'Send',
                sv: 'Skicka',
                de: 'Senden',
                no: 'Send'
            },
            cancel: {
                da: 'Annuller',
                'en-GB': 'cancel',
                sv: 'Avbryt',
                de: 'Absagen',
                no: 'Avbryt'
            },
            empty: {
                da: '',
                'en-GB': '',
                sv: '',
                de: '',
                no: ''
            }
        }

        private iteration = 0;
        private deadlock = 1;
        get(name: string, lang?: string): string {
            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }

            if (this.translations[name] == undefined || this.translations[name] == null) {
                return "Ukendt tekst";
            }

            var value = this.translations[name][langCode];
            if (value == undefined || value == "") {
                if (this.iteration >= this.deadlock) {
                    this.iteration = 0;
                    return "Oversættelse findes ikke";
                }
                this.iteration++;
                return this.get(name, "da");
            }
            this.iteration = 0;
            return value;
        }

    }

    export class GuestbookClient {

        totalRows: number;
        messages: IGuestbookMessage[];
        container: JQuery;
        guestbookId: number;
        currentPage: number;
        houses: IEmne[];
        houseId: number;
        topRowsToDisplay: number = 0;

        translations: GuestbookTranslations;

        constructor() {
            //<div data-componenttype="guestbook" data-id="1">Indl&aelig;ser <img src="~/content/siteimages/loadericons/small2.gif" alt="" /></div>
            var obj = $('*[data-componenttype="guestbook"]');
            if (obj.length === 0) {
                return;
            }
            this.houseId = 0;
            this.container = $(obj[0]);

            var houseId = this.container.attr("data-houseid");
            if (this.isNumeric(houseId)) {
                this.houseId = parseInt(houseId);
            }

            var topRowsToDisplay = this.container.attr("data-top");
            if (this.isNumeric(topRowsToDisplay)) {
                this.topRowsToDisplay = parseInt(topRowsToDisplay);
            }

            this.currentPage = 1;
            this.guestbookId = parseInt(this.container.attr("data-id"));

            this.translations = new GuestbookTranslations();

            this.start();
        }

        private isNumeric(n): boolean {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        private start() {
            var self = this;

            var xhr = $.getJSON("/api/getEmneListWithoutMarkers", function (houses: IEmne[]) {
                self.houses = houses;
            });
            xhr.always(function (jqxhr, textStatus, error) {
                self.getMessages(self.guestbookId);
            });
        }

        private filluser(): void {
            $.ajax({
                url: '/account/getUserInformation',
                type: 'get',
                dataType: 'json',
                success: function (result) {
                    $('#txtName').val(result.firstname);
                    $('#txtEmail').val(result.email);
                },
                error: function () {

                }
            });
        }

        private drawGuestbook() {
            var messagesString = "";

            messagesString += this.writeMessageDialog();
            messagesString += this.guestbookButtonbar();

            for (var i = 0; i < this.messages.length; i++) {
                var message = this.messages[i];

                var imageUrl = "";
                if (message.imageId > 0) {
                    imageUrl = `<img class="guestbook-image" src="/guestbookimage/${message.imageId}" />`;
                }

                messagesString += `<div class="card mt-4">
                        <div class="card-header">
                            <strong>${message.housetitle}</strong> &nbsp;·&nbsp; <span class="small">${message.name} &nbsp;·&nbsp;  ${$.datepicker.formatDate("dd-MM-yy", new Date(message.date as any))}</span>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-7 col-lg-8">
                                    <p>
                                        ${message.message}
                                    </p>
                                </div>
                                <div class="col-sm-5 col-lg-4 text-right">
                                    ${imageUrl}
                                </div>
                            </div>
                        </div>
                    </div>`;

                if (this.topRowsToDisplay > 0 && i >= this.topRowsToDisplay - 1) {
                    break;
                }
            }

            // Tilføj sideskift
            //messagesString += 
            //    `<nav class="d-flex justify-content-center mt-4">
            //        <ul class="pagination">
            //            <li class="page-item"><a class="page-link clickable" id="previouspage">Forrige</a></li>
            //            <li class="page-item"><a class="page-link clickable" id="nextpage">Næste</a></li>
            //        </ul>
            //    </nav>`;

            if (this.topRowsToDisplay <= 0) {
                messagesString += this.generatePageButtons();
            }

            this.container.html(messagesString);

            var self = this;
            $("#nextpage").click(function () {
                self.nextpage();
            });
            $("#previouspage").click(function () {
                self.previouspage();
            });
            $('[data-pagenumber]').on('click', function () {
                var pageNumber = $(this).data('pagenumber');
                self.currentPage = pageNumber;
                self.getMessages(self.guestbookId, self.scrollToTop);
            });
            $(".showAddnew").click(function () {
                $("#guestbookWriteNew").show("slow");
            });
            $("#collapseAddnew").click(function () {
                $("#guestbookWriteNew").hide("slow");
            });

            $('#fileUpload').on('change', function (e) {
                var [file] = this.files;
                if (file && file.type.indexOf('image') > -1) {
                    $('#previewImage').prop('src', URL.createObjectURL(file));
                    $('#previewImage').css('height', 'auto');
                    $('#previewImage').css('display', 'block');
                }
                else if (file) {
                    $('#previewImage').prop('src', '/content/siteimages/file.png');
                    $('#previewImage').css('height', '50px');
                    $('#previewImage').css('display', 'block');
                }
                else {
                    $('#previewImage').css('display', 'none');
                }
            });

            $("#btnSkrivIndlæg").click(function () {
                //if ($("#guestbookwritemessageform").valid() === false) {
                //    return;
                //}

                // send besked..
                var ajaxData = new FormData();
                var file = $("#fileUpload")[0].files[0];
                if (file) {
                    ajaxData.append("file", file);
                }
                ajaxData.append("name", $("#txtName").val());
                ajaxData.append("email", $("#txtEmail").val());
                ajaxData.append("message", $("#txtMessage").val());
                ajaxData.append("houseid", $("#houseid").val());
                ajaxData.append("guestbookId", self.guestbookId.toString());

                $.ajax({
                    url: $("#guestbookwritemessageform").attr("action"),
                    type: $("#guestbookwritemessageform").attr("method"),
                    data: ajaxData,
                    dataType: "json",
                    cache: false,
                    contentType: false,
                    processData: false,
                    complete() {

                    },
                    success(data) {
                        if (data.length === 0) {
                            $("#guestbookWriteNew").hide("slow");
                            self.currentPage = 1;
                            self.getMessages(self.guestbookId);
                        } else {
                            $("#guestbookerror").html(data);
                        }
                    },
                    error() {

                    }
                });
            });

            $("#guestbookShowMessagesForThisHouse").on("change",
                function () {
                    var tmp = $(this)[0];
                    self.houseId = tmp.value;
                    self.currentPage = 1;
                    self.getMessages(self.guestbookId);
                });

            $(document).on("change", ".btn-file :file", function () {
                var input = $(this),
                    numFiles = input.get(0).files ? input.get(0).files.length : 1,
                    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
                input.trigger("fileselect", [numFiles, label]);
            });
            $(document).ready(function () {
                $(".btn-file :file").on("fileselect", function (event, numFiles, label) {

                    var input = $(this).parents('.input-group').find(':text'),
                        log = numFiles > 1 ? numFiles + ' files selected' : label;

                    if (input.length) {
                        input.val(log);
                    } else {
                        if (log) alert(log);
                    }

                });
            });
        }

        private generatePageButtons(): string {
            var totalPages = Math.ceil(this.totalRows / 25);

            var pageButtons = "";
            for (var i = 1; i <= totalPages; i++) {
                pageButtons +=
                    this.currentPage == i ?
                        `<li class="pagenumbers-active brand-background">
                        <span>${i}</span>
                    </li>` :
                        `<li>
                        <a class="clickable" data-pagenumber="${i}">
                            <span>${i}</span>
                        </a>
                    </li>`;
            }

            var result = `<nav class="mt-4">
                    <ul class="pagenumbers d-flex justify-content-center align-items-start">
                        <li class="pagenumbers-previous ${this.currentPage <= 1 ? 'pagenumbers-disabled' : ''}"><a class="clickable" id="previouspage"></a></li>
                        ${pageButtons}
                        <li class="pagenumbers-next ${this.currentPage >= totalPages ? 'pagenumbers-disabled' : ''}"><a class="clickable" id="nextpage"></a></li>
                    </ul>
                </nav>`;


            return result;
        }

        private nextpage() {
            if (this.currentPage === undefined) {
                this.currentPage = 1;
            } else {
                this.currentPage++;
            }

            this.getMessages(this.guestbookId, this.scrollToTop);
        }

        private previouspage() {
            if (this.currentPage === undefined) {
                this.currentPage = 1;
            }
            if (this.currentPage < 2) {
                return;
            }

            this.currentPage--;
            this.getMessages(this.guestbookId, this.scrollToTop);
        }

        private getMessages(guestbookId: number, callback: () => void = null) {
            this.container.html(`Indlæser <img src="/content/siteimages/loadericons/small2.gif" alt="" />`);

            var self = this;

            var xhr = $.getJSON("/api/guestbook/" + guestbookId + "?pagenumber=" + this.currentPage + "&houseid=" + this.houseId, function (result: { totalRows: number, messages: IGuestbookMessage[] }) {
                self.totalRows = result.totalRows;
                self.messages = result.messages;
            });
            xhr.always(function (jqxhr, textStatus, error) {
                self.drawGuestbook();
                self.filluser();
                if (callback) {
                    callback();
                }
            });
        }

        private scrollToTop(): void {
            var top = 0;
            if ($('[data-componenttype="guestbook"]').length > 0) {
                top = $('[data-componenttype="guestbook"]').offset().top;
            }
            $('html, body').animate({ scrollTop: top }, "fast");
        }


        private guestbookButtonbar(): string {
            var housesString = ``;
            for (var i = 0; i < this.houses.length; i++) {
                var selected = "";
                if (this.houses[i].id == this.houseId) {
                    selected = ` selected="selected"`;
                }
                housesString += `<option value="${this.houses[i].id}" ${selected}>${this.houses[i].title}</option>`;
            }

            return `<div class="guestbook-button-bar bg-primary">
                <div class="row">
                    <div class="col-sm-8">
                        <select class="form-control" id="guestbookShowMessagesForThisHouse">
                            <option value="0">Alle</option>
                            ${housesString}
                        </select>
                    </div>
                    <div class="col-sm-4 text-right">
                        <span class="showAddnew btn btn-light">${this.translations.get('writepost')}</span>
                    </div>
                </div>
            </div>`;
        }

        private writeMessageDialog(): string {
            var housesString = ``;
            for (var i = 0; i < this.houses.length; i++) {
                var selected = "";
                if (this.houses[i].id == this.houseId) {
                    selected = ` selected="selected"`;
                }
                housesString += `<option value="${this.houses[i].id}" ${selected}>${this.houses[i].title}</option>`;
            }
            return `<div id="guestbookWriteNew" class="guestbook gbhidden"><span id="guestbookerror" class="text-danger"></span>
<form id="guestbookwritemessageform" role="form" novalidate="novalidate" action="/api/guestbook" enctype="multipart/form-data" method="post">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <input type="text" id="txtName" class="form-control" required placeholder="${this.translations.get('name')}" />
                        </div>

                        <div class="form-group">
                            <input type="text" id="txtEmail" class="form-control" required placeholder="${this.translations.get('email')}" />
                        </div>
                        
                        <div class="form-group">
                            <select class="form-control" id="houseid">
                                <option value="0">${this.translations.get('pickitem')}</option>
                                ${housesString}
                            </select>
                        </div>

                        <div class="form-group">
                            <span>${this.translations.get('attachfile')}</span>
                            <div class="input-group">
                                <span class="input-group-btn">
                                    <span class="btn btn-primary btn-file">${this.translations.get('pickfile')} <input type="file" id="fileUpload" class="form-control" /></span>
                                </span>
                                <input type="text" class="form-control" readonly>
                            </div>
                        </div>

                        <img id="previewImage" src="#" alt="Image preview" class="imagePreview mw-100" style="display: none;" />

                        
                    </div>

                    <div class="col-md-7 col-md-offset-1">
                        <div class="form-group">
                            <textarea ID="txtMessage" TextMode="MultiLine" class="form-control" Rows="7" required placeholder="${this.translations.get('message')}"></textarea>
                        </div>

                        <div class="form-group">
                            <input 
                                type="button" 
                                id="btnSkrivIndlæg" 
                                class="autoWidth btn btn-primary" 
                                value="${this.translations.get('send')}" />
                            <input type="button" class="autoWidth btn btn-secondary" id="collapseAddnew" value="${this.translations.get('cancel')}" />
                        </div>
                    </div>
                </div>
                <p>&nbsp;</p>
</form>
            </div>`;
        }
    }
}

($ => {
    var guestbook = new Bookhus.Widgets.GuestbookClient();
})(jQuery);

